import {useState, useEffect} from "react";
import {Link, useParams} from "react-router-dom";
import Booking from "../Components/Booking/Booking";
import RecentBlog from "../Components/RecentBlog/RecentBlog";
import {useLocation} from "react-router";
import NotFound from "./NotFound";

function ServiceDetail() {
    let courseId = useParams()['course_id'];
    const [activeTab, setActiveTab] = useState('tab1');
    const location = useLocation();
    const [data, setData] = useState([]);
    let details = location.state;

    const getData = () => {
        fetch("/Courses/courses.json", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (myJson) {
            setData(myJson[courseId])
        });
    }
    useEffect(() => {
        getData()
    }, [])
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <>
            {data ? (
                <>
                    <section className="serviceDetailSec">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="detailCard">
                                        <div className="videoCont">
                                            <figure>
                                                <img src={process.env.PUBLIC_URL + '/images/' + details.img} alt=""/>
                                                {/*<div className="videoControl-bar">*/}
                                                {/*    <button type="button" className="videoPlay-btn">*/}
                                                {/*        <i className="fas fa-play"/>*/}
                                                {/*    </button>*/}
                                                {/*    <div className="videoRange-bar"/>*/}
                                                {/*    <div className="videoTimer">*/}
                                                {/*        <h6>2:20/10:00</h6>*/}
                                                {/*    </div>*/}
                                                {/*    <button type="button" className="videoexpandBtn">*/}
                                                {/*        <i className="fas fa-expand-alt"/>*/}
                                                {/*    </button>*/}
                                                {/*    <button type="button" className="videolandscapeBtn">*/}
                                                {/*        <i className="far fa-rectangle-landscape"/>*/}
                                                {/*    </button>*/}
                                                {/*    <div className="videoVolume-btn">*/}
                                                {/*        <input type="range" value="30" min="0" max="100" className="range"/>*/}
                                                {/*        <button type="button">*/}
                                                {/*            <i className="fas fa-volume-down"/>*/}
                                                {/*        </button>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </figure>
                                        </div>
                                        <div className="content">
                                            <div className="infoCont">
                                                <h3 className="heading">
                                                    {data && (
                                                        data.title
                                                    )}
                                                    {/*DevOps Engineering course is the Key of Successful development*/}
                                                </h3>
                                                <div className="uploader">
                                                    <Link className="user">
                                                        <figure>
                                                            <img
                                                                src={process.env.PUBLIC_URL + '/images/' + details.uploader.img}
                                                                alt=""/>
                                                        </figure>
                                                        <div className="userDetail">
                                                            <h5 className="name">
                                                                {details.uploader.name}
                                                            </h5>
                                                            <p className="designation">
                                                                {details.uploader.pos}
                                                            </p>
                                                        </div>
                                                    </Link>
                                                    <div className="category">
                                                        <p>
                                                            {details.cat}
                                                        </p>
                                                    </div>
                                                    <div className="actionBtnCont">
                                                        <button><i className="fas fa-plus"/> Follow Mentor</button>
                                                    </div>
                                                    <div className="rating">
                                                        <span>5.0</span>
                                                        <i className="fas fa-star"/>
                                                        <i className="fas fa-star"/>
                                                        <i className="fas fa-star"/>
                                                        <i className="fas fa-star"/>
                                                        <i className="fas fa-star"/>
                                                    </div>
                                                </div>
                                                <div className="minDetails">
                                                    <p className="detail">
                                                        <i className="far fa-user"/>
                                                        <span>500 Students</span>
                                                    </p>
                                                    <p className="detail">
                                                        <i className="far fa-clock"/>
                                                        <span>16 hr 30 mins</span>
                                                    </p>
                                                    <div className="live">
                                                        <p>Live Sessions</p>
                                                        <i className="far fa-signal-stream"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="descriptionCont">
                                                <ul className="descTabs">
                                                    {data.description && (
                                                        <li>
                                                            <button
                                                                id="tab1"
                                                                className={activeTab === 'tab1' ? 'active' : ''}
                                                                onClick={() => handleTabClick('tab1')}
                                                            >
                                                                About
                                                            </button>
                                                        </li>
                                                    )}
                                                    {data.assignment && (
                                                        <li>
                                                            <button
                                                                id="tab2"
                                                                className={activeTab === 'tab2' ? 'active' : ''}
                                                                onClick={() => handleTabClick('tab2')}
                                                            >
                                                                Assignment
                                                            </button>
                                                        </li>
                                                    )}
                                                    {data.tool && (
                                                        <li>
                                                            <button
                                                                id="tab3"
                                                                className={activeTab === 'tab3' ? 'active' : ''}
                                                                onClick={() => handleTabClick('tab3')}
                                                            >
                                                                Tools
                                                            </button>
                                                        </li>
                                                    )}
                                                    {/*<li>*/}
                                                    {/*    <button*/}
                                                    {/*        id="tab4"*/}
                                                    {/*        className={activeTab === 'tab4' ? 'active' : ''}*/}
                                                    {/*        onClick={() => handleTabClick('tab4')}*/}
                                                    {/*    >*/}
                                                    {/*        Review*/}
                                                    {/*    </button>*/}
                                                    {/*</li>*/}
                                                </ul>
                                                {data.description && (
                                                    <div className={activeTab === 'tab1' ? 'tab active' : 'tab'}>
                                                        <div className="descriptionBox">
                                                            <h4 className="heading">
                                                                Description
                                                            </h4>
                                                            {data.description && (
                                                                <p>
                                                                    {data.description}
                                                                </p>
                                                            )}
                                                            {data.keyPoints && data.keyPoints.length > 0 && (
                                                                <>
                                                                    <h4 className="heading">
                                                                        Key Point
                                                                    </h4>
                                                                    <ul>
                                                                        {
                                                                            data.keyPoints.map((item, index) =>
                                                                                <li key={index}>
                                                                                    <i className="fas fa-check-circle"/>
                                                                                    <span><strong>{item.head}</strong> {item.body}</span>
                                                                                </li>)
                                                                        }
                                                                    </ul>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {data.assignment && (
                                                    <div className={activeTab === 'tab2' ? 'tab active' : 'tab'}>
                                                        <div className="descriptionBox">
                                                            <h4 className="heading">
                                                                Assignment
                                                            </h4>

                                                            <p>
                                                                {data.assignment}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                                {data.tool && (
                                                    <div className={activeTab === 'tab3' ? 'tab active' : 'tab'}>
                                                        <div className="descriptionBox">
                                                            <h4 className="heading">
                                                                Tools
                                                            </h4>
                                                            {data.tool.desc && (
                                                                <p>
                                                                    {data.tool.desc}
                                                                </p>
                                                            )}
                                                            {data.tool.list && (
                                                                <ul>
                                                                    {
                                                                        data.tool.list.map((item, index) =>
                                                                            <li key={index}>
                                                                                <i className="fas fa-check-circle"/>
                                                                                <span><strong>{item.head}</strong> {item.body}</span>
                                                                            </li>)
                                                                    }
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    {data.side && (
                                        <div className="detailCard small">
                                            <div className="content">
                                                <div className="infoCont">
                                                    {data.side.head && (
                                                        <h3 className="heading">
                                                            {data.side.head}
                                                        </h3>
                                                    )}
                                                    {/*<div className="uploader">*/}
                                                    {/*    <Link className="user">*/}
                                                    {/*        <figure>*/}
                                                    {/*            <img src={process.env.PUBLIC_URL + '/images/user1.webp'} alt=""/>*/}
                                                    {/*        </figure>*/}
                                                    {/*        <div className="userDetail">*/}
                                                    {/*            <h5 className="name">*/}
                                                    {/*                Austin*/}
                                                    {/*            </h5>*/}
                                                    {/*            <p className="designation">*/}
                                                    {/*                Designer*/}
                                                    {/*            </p>*/}
                                                    {/*        </div>*/}
                                                    {/*    </Link>*/}
                                                    {/*    <div className="rating">*/}
                                                    {/*        <span>5.0</span>*/}
                                                    {/*        <i className="fas fa-star"/>*/}
                                                    {/*        <i className="fas fa-star"/>*/}
                                                    {/*        <i className="fas fa-star"/>*/}
                                                    {/*        <i className="fas fa-star"/>*/}
                                                    {/*        <i className="fas fa-star"/>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                </div>
                                                <div className="module">
                                                    {/*<div className="progress">*/}
                                                    {/*    <div className="bar">*/}
                                                    {/*        <span className="completed"/>*/}
                                                    {/*    </div>*/}
                                                    {/*    <div className="info">*/}
                                                    {/*        <span>1/5 Module</span>*/}
                                                    {/*        <span>20%</span>*/}
                                                    {/*    </div>*/}
                                                    {/*    <div className="info">*/}
                                                    {/*        <strong>5 Module</strong>*/}
                                                    {/*        <span>1/5 Done</span>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {data.side.body && (
                                                        <ul>
                                                            {
                                                                data.side.body.map((item, index) =>
                                                                    <li key={index}>
                                                                        <i className="fas fa-check-circle"/>
                                                                        <h6>
                                                                            {item}
                                                                        </h6>
                                                                    </li>)
                                                            }
                                                        </ul>
                                                    )}
                                                    {/*<Link to='/apply-now' className='themeBtn'>Apply Now</Link>*/}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    <Booking/>

                    <RecentBlog/>
                </>
            ) : <NotFound/>}
        </>
    )
}

export default ServiceDetail